// extracted by mini-css-extract-plugin
export default {"warningPopUpBox":"TabComponent_warningPopUpBox__0FCPk"};